import React, { useState } from "react";
import { T } from "./theme";
import { SectionHeader, Card, Input, Textarea, Btn, Note } from "./ui";
import { Icon } from "./Icons";

// ═══════════════════════════════════════════════════════════════════════
// PRÊMIOS (admin) — edita os 3 prêmios anuais grandes
// ═══════════════════════════════════════════════════════════════════════

const PREMIO_META = [
  { key: "iphone",   titulo: "iPhone do ano",        icone: "📱", cor: T.gold,     award: "Golden" },
  { key: "cruzeiro", titulo: "Cruzeiro de luxo",      icone: "🚢", cor: T.platinum, award: "Platinum" },
  { key: "byd",      titulo: "Veículo BYD elétrico",  icone: "🚗", cor: T.diamond,  award: "Diamond" },
];

export default function Premios({ premios, setPremios }) {
  const [edits, setEdits] = useState(premios);
  const [saved, setSaved] = useState(false);

  function salvar() {
    setPremios(edits);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <SectionHeader
        title="Prêmios Anuais"
        subtitle="Edite nome, descrição e requisitos dos prêmios grandes (aparecem no perfil dos corretores)"
        icon={<Icon.gift size={24} />}
        right={<Btn onClick={salvar} icon={<Icon.check size={14} />}>Salvar alterações</Btn>}
      />

      {saved && (
        <Note tone="ok" icon={<Icon.check size={14} />}>
          Prêmios atualizados com sucesso! As mudanças já aparecem no perfil dos corretores.
        </Note>
      )}

      <Note tone="info" icon={<Icon.info size={14} />}>
        <b>Novo modelo:</b> Os prêmios são <b>acumulativos</b> e dependem apenas do <b>volume em R$</b> no ciclo anual. Atingir R$ 2M → iPhone. Atingir R$ 3M → iPhone + Cruzeiro. Atingir R$ 5M → os 3 prêmios. Elegibilidade aberta: qualquer corretor que bater a meta de volume se qualifica, sem limite de quantos. Este painel edita apenas os textos visíveis no app.
      </Note>

      <div style={{ display: "grid", gap: 16 }}>
        {PREMIO_META.map(meta => {
          const p = edits[meta.key];
          return (
            <Card key={meta.key}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
                <div style={{ fontSize: 36, lineHeight: 1 }}>{meta.icone}</div>
                <div>
                  <div className="serif" style={{ fontSize: 20, fontWeight: 600, color: T.brand, letterSpacing: -0.3 }}>
                    {p.nome}
                  </div>
                  <div style={{ fontSize: 11, color: T.textSub, marginTop: 2 }}>
                    Volume exigido no ano: <b style={{ color: meta.cor }}>
                      {meta.key === "iphone" ? "R$ 2.000.000" : meta.key === "cruzeiro" ? "R$ 3.000.000" : "R$ 5.000.000"}
                    </b> em vendas diretas
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <Input
                  label="Nome do prêmio"
                  value={p.nome}
                  onChange={e => setEdits({ ...edits, [meta.key]: { ...p, nome: e.target.value } })}
                />
                <Textarea
                  label="Descrição"
                  value={p.descricao}
                  onChange={e => setEdits({ ...edits, [meta.key]: { ...p, descricao: e.target.value } })}
                  rows={2}
                />
                <div style={{ display: "grid", gridTemplateColumns: "1fr 120px", gap: 12 }}>
                  <Input
                    label="Requisito completo (texto)"
                    value={p.requisito}
                    onChange={e => setEdits({ ...edits, [meta.key]: { ...p, requisito: e.target.value } })}
                  />
                  <Input
                    label="Ano do prêmio"
                    type="number"
                    value={p.ano}
                    onChange={e => setEdits({ ...edits, [meta.key]: { ...p, ano: Number(e.target.value) } })}
                  />
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
